export default class extends HTMLElement {
  connectedCallback () {
    this.updateState()

    if (this.input) {
      this.input.addEventListener('input', () => this.updateState())
      this.input.addEventListener('change', () => this.updateState())
      this.input.addEventListener('keyup', () => this.updateState())
    }

    if (this.button) {
      this.button.addEventListener('click', (e) => {
        if (this.hasValue) {
          e.preventDefault()
          e.stopPropagation()
          this.clear()
        }
      })
    }
  }

  get input () {
    return this.querySelector('input')
  }

  get button () {
    return this.querySelector('.search-icon-btn') || this.querySelector('button')
  }

  get magnifierIcon () {
    return this.querySelector('.icon-magnifier')
  }

  get clearIcon () {
    return this.querySelector('.icon-clear')
  }

  get hasValue () {
    return this.input && this.input.value.trim().length > 0
  }

  updateState () {
    if (!this.magnifierIcon || !this.clearIcon) return

    if (this.hasValue) {
      this.magnifierIcon.classList.add('hidden')
      this.clearIcon.classList.remove('hidden')
      if (this.button) {
        this.button.classList.add('cursor-pointer')
        this.button.classList.remove('cursor-default')
        this.button.setAttribute('title', 'Clear search')
      }
    } else {
      this.magnifierIcon.classList.remove('hidden')
      this.clearIcon.classList.add('hidden')
      if (this.button) {
        this.button.classList.remove('cursor-pointer')
        this.button.classList.add('cursor-default')
        this.button.removeAttribute('title')
      }
    }
  }

  clear () {
    if (!this.input) return

    const hadValue = this.input.value.length > 0
    this.input.value = ''
    this.updateState()

    this.input.dispatchEvent(new Event('input', { bubbles: true }))
    this.input.dispatchEvent(new Event('change', { bubbles: true }))

    const form = this.input.closest('form')
    if (form && hadValue) {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit()
      } else {
        form.submit()
      }
    } else {
      this.input.focus()
    }
  }
}
